import { Component, Input, OnInit } from "@angular/core";
import {getUserType} from "../../utils/userType";

@Component({
    selector: "app-user-icon",
    templateUrl: "./user-icon.component.html",
    styleUrls: ["./user-icon.component.scss"],
})
export class UserIconComponent implements OnInit {
    @Input() type: string;
    @Input() isPremium: string;
    @Input() width: string;
    @Input() height: string;

    typeName = "";

    constructor() {}

    ngOnInit(): void {
        this.typeName = getUserType({
            isPremium: this.isPremium,
            type: this.type,
        });
    }
    accountIconMap = {
        trade: "trade.svg",
        customer: "customer.svg",
        supplier: "supplier.svg",
        admin: "admin.svg",
        courier: "courier.svg",
        tradepremium: "trade-premium.svg",
    };

    getCustomerIcon() {
        if (this.type in this.accountIconMap) {
            if (this.type === "trade" && this.isPremium) {
                return `assets/images/users/${this.accountIconMap["tradepremium"]}`;
            }
            return `assets/images/users/${this.accountIconMap[this.type]}`;
        }
        return `assets/images/users/guest.svg`;
    }
}
